
import { useState, useEffect } from 'react'
import { isEmpty, isNil } from 'ramda'

const useForm = ({ callback, validate, initValues }) => {
    const [values, setValues] = useState(initValues || {});
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isEmpty(errors) && isSubmitting) {
            (async () => {
                try {
                    callback(values)
                } catch (err) {
                    setErrors(err)
                }
                setIsSubmitting(false);
            })()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errors, isSubmitting]);

    useEffect(() => {
        if (isEmpty(values) && !isEmpty(initValues) && !isNil(initValues)) {
            setValues(initValues || {})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initValues]);

    const handleSubmit = (event) => {
        if (event) event.preventDefault();
        validate && setErrors(validate(values));
        setIsSubmitting(true);
    };

    const handleChange = (event) => {
        event.persist && event.persist();
        if (event.target.type === 'checkbox') {
            setValues(values => ({ ...values, [event.target.name]: event.target.checked }));
        } else {
            setValues(values => ({ ...values, [event.target.name]: event.target.value }));
        }
    };

    return {
        handleChange,
        handleSubmit,
        values,
        errors,
        setError: error => setErrors(prevErrors => ({ ...prevErrors, ...error })),
        setValue: value => setValues(prevValues => ({ ...prevValues, ...value }))
    }
};


export default useForm